<template>
  <div class="contents Signin__back">
    <form class="inner" @submit.prevent="onsubmit($event)">
      <div>
        <img alt="melon online" class="Signin__logo" src="assets/img/melon_logo_white.png">
      </div>

      <div :class="`Signin__area ${showError ? '_error': ''}`">
        <div class="Signin__error">
          <p class="Signin__error_top_tx">
            ユーザID、パスワードの入力に誤りがあるか登録されていません。
          </p>
          <p class="Signin__error_tx">
            正しいユーザID、パスワードを入力してもログインできない場合は、
            <router-link
              class="Signin__error_tx_link"
              to="forgot-password"
            >
              こちら
            </router-link>
            からパスワードの再設定を行なってください。
          </p>
        </div>
        <div class="Signin__input_area">
          <div class="Signin__input_box ">
            <div class="Signin__input_head">
              メールアドレス
            </div>
            <input
              v-model="user.email"
              class="Signin__input"
              placeholder="sample@gmail.com"
              type="email"
            >
          </div>
          <div class="Signin__input_box">
            <div class="Signin__input_head">
              パスワード
            </div>
            <input
              v-model="user.password"
              class="Signin__input"
              type="password"
            >
          </div>
        </div>
        <button class="Signin__btn" :disabled="isLoading" type="submit">
          ログイン
        </button>
        <div class="Signin__btn_area">
          <router-link class="Btn__dotted Btn__dotted--white _mg-b20" to="/forgot-password">
            パスワードを忘れた方はこちら
          </router-link>
          <a v-show="!isApp" class="Btn__dotted Btn__dotted--white" @click="redirectToMemberRegister()">
            新規登録の方はこちら
          </a>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { redirect } from '@/helpers'
import firebaseService from '@/services/firebaseService'
import Cookies from 'js-cookie'

export default {
  name: 'Login',
  mixins: [validationMixin],
  data() {
    return {
      user: {
        email: '',
        password: ''
      },
      showError: false,
      isLoading: false,
      isApp: false
    }
  },
  mounted() {
    this.checkRunInApp()
  },
  methods: {
    onsubmit() {
      this.isLoading = true
      const redirectPath = this.$route.query.redirect ?? '/'
      this.$store.dispatch('user/login', this.user).then(data => {
        this.showError = false
        redirect(redirectPath)
      }).catch(() => {
        this.showError = true
      }).finally(() => {
        this.isLoading = false
        const isSupported = 'Notification' in window && 'serviceWorker' in navigator && 'PushManager' in window
        if (isSupported) {
          firebaseService.getToken()
        }
      })
    },
    redirectToMemberRegister() {
      localStorage.removeItem('email')
      localStorage.removeItem('step1')
      localStorage.removeItem('step2')
      this.$store.dispatch('auth/resetStep', this.user)
      this.$router.push('member-register')
    },
    checkRunInApp() {
      if (this.$route.query.isApp === '1') {
        Cookies.set('isApp', '1')
      }
      this.isApp = Cookies.get('isApp') === '1'
    }
  }
}
</script>
